module.exports = __webpack_public_path__ + "send-4013883839386b256921.png";